import m from "mithril";
import {elementId, hideSwitch, simpleContent} from './helpers'
import {RadioItem} from '../../model/items/radio'
import {inputTextItemView} from './inputText'

export function radioItemView(c:RadioItem) {

	return c.isVisible() ? m('.radio.centered', {
		className: (hideSwitch(c.childrenTags) ? 'hide-switch ' : '') +
					(c.cell.enabled ? 'control-enabled ' : 'control-disabled '),
        tabindex: "1",
		onclick: c.set.bind(c),
        ontouchstart: () => { },
        onmouseover: () => {c.storeVirtualValue()},
        onmouseout: () => {c.resetVirtualValue()},
	}, [
		m('input[type=radio]', {id: elementId(c, c.cell.id), checked: c.isChecked(), disabled: !c.cell.enabled}),
		m('label', simpleContent(c, c.childrenTags, c.showAsActive())),
        c.cell.hasInputText() ? inputTextItemView(c.cell.getInputText()!) : '' // c.cell.getInputText() is checked

	]) : null;
}
